import { Loader } from '@/components/Common';
import * as React from 'react';
import { useCreditCallback } from '../hooks';

export const CreditCallback = () => {
  useCreditCallback();

  return (
    <div style={{ height: '100vh', display: 'grid', placeItems: 'center' }}>
      <Loader />
    </div>
  );
};
